'use client';

import React, { memo, useMemo } from 'react';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  src = '',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick}>
      {src ? (
        <AppImage
          src={src}
          alt="Infinite Content Logo"
          width={size}
          height={size}
          className="flex-shrink-0"
          priority={true}
          unoptimized={src.endsWith('.svg')}
        />
      ) : (
        <svg
          width={size}
          height={size}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-shrink-0"
          aria-label="Infinite Content logo"
        >
          <rect width="40" height="40" rx="10" fill="#6C47FF" />
          <path
            d="M8 20c0-3.314 2.686-6 6-6 2.21 0 4.144 1.196 5.196 2.98L20 18.5l.804-1.52C21.856 15.196 23.79 14 26 14c3.314 0 6 2.686 6 6s-2.686 6-6 6c-2.21 0-4.144-1.196-5.196-2.98L20 21.5l-.804 1.52C18.144 24.804 16.21 26 14 26c-3.314 0-6-2.686-6-6z"
            fill="white"
            stroke="white"
            strokeWidth="0.5"
          />
          <path
            d="M14 16.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5c1.38 0 2.576-.8 3.17-1.97l1.33-2.53C17.706 17.63 15.96 16.5 14 16.5z"
            fill="#6C47FF"
          />
          <path
            d="M26 16.5c-1.96 0-3.706 1.13-4.5 2.5l1.33 2.53C23.424 22.7 24.62 23.5 26 23.5c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5z"
            fill="#6C47FF"
          />
        </svg>
      )}
    </div>
  );
});

export default AppLogo;
